import { DS_ICON_SIZES, DSIconSize } from "@/src/design_system/primitives/icon/types";
import { DS_SIZE } from "@/src/design_system/shared/types/size";
import type { DSBadgeContentProps } from "@/src/design_system/data_display/badge/types/props";

export const DS_BADGE_ICON_SIZE_MAP: Record<DSBadgeContentProps["size"], DSIconSize> = {
  [DS_SIZE.Small]: DS_ICON_SIZES.ExtraSmall,
  [DS_SIZE.Medium]: DS_ICON_SIZES.ExtraSmall,
  [DS_SIZE.Large]: DS_ICON_SIZES.Small,
  [DS_SIZE.ExtraLarge]: DS_ICON_SIZES.Small,
};
